import { ErrorMessage } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

export const TextAreaFormGroup: React.FC<{
  fieldName: string;
  fieldDisplayName: string | React.ReactNode;
  placeholder?: string;
  error?: string;
  value?: string;
  disabled: boolean;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(
      field: T_1
    ): T_1 extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  keywords?: string | React.ReactNode;
  className?: string;
}> = (props) => {
  return (
    <Form.Group className={props.className}>
      <div className="d-flex align-items-center">
        <Form.Label className="flex-grow-1">
          {props.fieldDisplayName}
        </Form.Label>
      </div>
      {props.keywords && (
        <Form.Text className="mt-0 mb-2">{props.keywords}</Form.Text>
      )}
      <Form.Control
        isInvalid={props.error != null}
        name={props.fieldName}
        placeholder={props.placeholder}
        value={props.value ?? ""}
        disabled={props.disabled}
        onChange={props.handleChange}
        as="textarea"
        rows={10}
      />
      <ErrorMessage
        name={props.fieldName}
        component={Form.Text}
        className="text-danger"
      />
    </Form.Group>
  );
};
